import { images } from '../constants';

const services = [
    {
    id: 1,
    image: images.service1,
    title: 'Custom Craft',
    content: 'Crafting custom-made furniture, cabinets, and other wooden items tailored to clients\' needs.',
    paragraphs: [
        'Bring your vision to life with our bespoke woodworking solutions. From handcrafted furniture to tailored cabinetry, we create pieces that perfectly match your space, style, and specifications.',
        'Our craftsmen combine traditional techniques with modern tools to deliver precision, durability, and elegance in every project. Whether for home or commercial spaces, we ensure unmatched quality and attention to detail.'
    ],
    gallery: [
        images.service1Gallery1,
        images.service1Gallery2
    ],
    features: [
        'Tailored Furniture Designs',
        'Premium Wood Selections',
        'Expert Joinery & Finishes',
        'Design-to-Delivery Service',
        'Sustainable Crafting Practices'
    ],
    procedure: [
        'Initial Consultation',
        'Concept Design & Approval',
        'Material Selection',
        'Crafting & Assembly',
        'Final Delivery & Setup'
    ],
    faqs: [
        {
            id: 1,
            heading: 'What types of custom items can you build?',
            content: 'We specialize in custom furniture, cabinets, shelves, and other wood-based items. If you can dream it, we can build it.'
        },
        {
            id: 2,
            heading: 'Can I choose the type of wood?',
            content: 'Yes, we offer a variety of wood types and finishes. Our experts will guide you based on durability, aesthetics, and your budget.'
        },
        {
            id: 3,
            heading: 'How long does a custom project take?',
            content: 'Project timelines vary depending on size and complexity, but most custom orders are completed within 2–4 weeks after design approval.'
        },
        {
            id: 4,
            heading: 'Do you provide delivery and installation?',
            content: 'Absolutely. We handle everything from delivery to final installation, ensuring your piece fits perfectly and is securely set up.'
        }
    ]
    },
    {
        id: 2,
        image: images.service2,
        title: 'Carpentry Work',
        content: 'General carpentry work including framing, trim work, and finishing carpentry.',
        paragraphs: [
            'From structural framing to fine finishing, our carpentry services cover every aspect of wood construction and detailing. Whether you’re building new structures or enhancing existing ones, we bring precision and skill to every project.',
            'Our team of experienced carpenters is committed to quality craftsmanship, timely execution, and lasting results. We ensure each cut, joint, and installation is carried out with the utmost care and attention.'
        ],
        gallery: [
            images.service2Gallery1,
            images.service2Gallery2
        ],
        features: [
            'Structural Framing',
            'Trim & Molding Installation',
            'Door & Window Fitting',
            'Finish Carpentry Expertise',
            'Reliable On-Site Execution'
        ],
        procedure: [
            'Site Assessment',
            'Material Planning',
            'Framework Construction',
            'Detail Finishing',
            'Final Inspection & Cleanup'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What types of carpentry services do you offer?',
                content: 'We offer framing, trim installation, baseboards, crown molding, custom shelving, door fitting, and more.'
            },
            {
                id: 2,
                heading: 'Do you work on residential and commercial projects?',
                content: 'Yes, our carpentry team is equipped to handle both residential renovations and commercial build-outs with the same level of professionalism.'
            },
            {
                id: 3,
                heading: 'Can you help with design and material choices?',
                content: 'Definitely. We offer consultations to help you choose the best design and materials based on your goals and budget.'
            },
            {
                id: 4,
                heading: 'How do you ensure quality in your carpentry work?',
                content: 'We use premium materials, follow proven methods, and perform detailed inspections to guarantee high-quality and durable finishes.'
            }
        ]
    },
    {
        id: 3,
        image: images.service3,
        title: 'Furniture Repair',
        content: 'Repairing and restoring antique or damaged wooden furniture to its former glory.',
        paragraphs: [
            'Give your cherished wooden furniture a second life with our expert repair and restoration services. Whether it’s a beloved heirloom or a damaged favorite, we bring back its original beauty and structural integrity.',
            'Our skilled craftsmen specialize in everything from joint stabilization and refinishing to intricate detailing and antique preservation, ensuring your furniture looks stunning and stands the test of time.'
        ],
        gallery: [
            images.service3Gallery1,
            images.service3Gallery2
        ],
        features: [
            'Antique Furniture Restoration',
            'Scratch & Dent Repairs',
            'Re-Glueing & Reinforcement',
            'Custom Color Matching',
            'Finish Stripping & Refinishing'
        ],
        procedure: [
            'Initial Assessment',
            'Damage Analysis',
            'Repair & Stabilization',
            'Surface Refinishing',
            'Final Touches & Protection'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What types of furniture do you repair?',
                content: 'We repair all types of wooden furniture including chairs, tables, cabinets, dressers, and antique pieces.'
            },
            {
                id: 2,
                heading: 'Can you restore the original finish?',
                content: 'Yes, we specialize in restoring or replicating the original finish using color matching and traditional techniques.'
            },
            {
                id: 3,
                heading: 'Do you provide antique restoration?',
                content: 'Absolutely. Our team has experience handling antique restorations with the care and attention these valuable items deserve.'
            },
            {
                id: 4,
                heading: 'Is the repair visible after restoration?',
                content: 'Our goal is to make repairs as seamless as possible. Most restorations are virtually invisible to the untrained eye.'
            }
        ]
    },
    {
        id: 4,
        image: images.service4,
        title: 'Cabinet Design',
        content: 'Designing, building, and installing custom cabinets for kitchens, bathrooms, and other spaces.',
        paragraphs: [
            'Transform your spaces with our expertly crafted custom cabinets. Whether it’s for your kitchen, bathroom, or storage area, we design and build cabinets tailored to your layout, style, and functionality needs.',
            'From sleek modern lines to timeless classic finishes, our team ensures top-quality materials, precise construction, and flawless installation to give your interiors a polished and organized look.'
        ],
        gallery: [
            images.service4Gallery1,
            images.service4Gallery2
        ],
        features: [
            'Custom Cabinet Designs',
            'Kitchen & Bathroom Solutions',
            'Premium Wood & Hardware',
            'Space Optimization',
            'Flawless Installation'
        ],
        procedure: [
            'Design Consultation',
            '3D Layout & Planning',
            'Material Selection',
            'Cabinet Fabrication',
            'Professional Installation'
        ],
        faqs: [
            {
                id: 1,
                heading: 'Do you offer custom designs for all spaces?',
                content: 'Yes, we create custom cabinet solutions for kitchens, bathrooms, closets, offices, and other unique areas in your home.'
            },
            {
                id: 2,
                heading: 'What materials do you use?',
                content: 'We use high-quality solid wood, plywood, MDF, and premium hardware, depending on your preferences and budget.'
            },
            {
                id: 3,
                heading: 'Can I see a preview before installation?',
                content: 'Definitely. We provide 3D renderings during the design phase so you can visualize the final look before fabrication.'
            },
            {
                id: 4,
                heading: 'How long does the cabinet installation take?',
                content: 'The timeline varies based on the complexity, but most projects are completed within 1 to 2 weeks after design approval.'
            }
        ]
    },
    {
        id: 5,
        image: images.service5,
        title: 'Flooring Installation',
        content: 'Installing new hardwood floors or refinishing existing ones to revitalize their appearance.',
        paragraphs: [
            'Elevate the look and feel of your space with expertly installed hardwood flooring. Our team handles everything from installing brand-new hardwood floors to restoring and refinishing existing ones.',
            'We bring life back to worn-out floors with sanding, staining, and sealing, or help you choose the perfect new material that matches your home’s style and functionality needs.'
        ],
        gallery: [
            images.service5Gallery1,
            images.service5Gallery2
        ],
        features: [
            'Hardwood Floor Installation',
            'Floor Sanding & Refinishing',
            'Custom Stain Options',
            'Durable & Elegant Finishes',
            'Expert Craftsmanship'
        ],
        procedure: [
            'Initial Assessment',
            'Material Selection',
            'Surface Preparation',
            'Floor Installation or Refinishing',
            'Final Inspection & Cleanup'
        ],
        faqs: [
            {
                id: 1,
                heading: 'Do you install all types of hardwood flooring?',
                content: 'Yes, we install solid hardwood, engineered wood, and laminate flooring tailored to your design and durability needs.'
            },
            {
                id: 2,
                heading: 'Can you refinish old hardwood floors?',
                content: 'Absolutely. We specialize in sanding and refinishing to restore the original beauty of your floors.'
            },
            {
                id: 3,
                heading: 'How long does the installation process take?',
                content: 'Most flooring projects are completed within 2 to 5 days, depending on the size and complexity of the job.'
            },
            {
                id: 4,
                heading: 'Will I need to leave my home during refinishing?',
                content: 'It depends on the finish used. We’ll advise you beforehand if temporary relocation is necessary for safety and comfort.'
            }
        ]
    },
    {
        id: 6,
        image: images.service6,
        title: 'Deck Construction',
        content: 'Designing and constructing wooden decks for residential or commercial properties.',
        paragraphs: [
            'Create the perfect outdoor living space with our expert deck construction services. From concept to completion, we design and build custom wooden decks that blend beauty with durability.',
            'Whether for relaxing evenings at home or entertaining guests, our decks are crafted with precision and built to withstand the elements while enhancing your property’s value and charm.'
        ],
        gallery: [
            images.service6Gallery1,
            images.service6Gallery2
        ],
        features: [
            'Custom Deck Designs',
            'Quality Wood Materials',
            'Weather-Resistant Finishes',
            'Residential & Commercial Builds',
            'Sturdy, Long-Lasting Construction'
        ],
        procedure: [
            'Site Evaluation & Measurements',
            'Design Planning & Material Selection',
            'Foundation & Frame Construction',
            'Decking Installation',
            'Final Touches & Safety Checks'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What types of wood do you use for deck construction?',
                content: 'We use a variety of high-quality woods including cedar, redwood, pressure-treated lumber, and composite decking options.'
            },
            {
                id: 2,
                heading: 'Can you help design a custom deck layout?',
                content: 'Yes, we work closely with you to design a layout that fits your space, style, and functional needs.'
            },
            {
                id: 3,
                heading: 'How long does it take to build a deck?',
                content: 'Depending on size and complexity, deck construction typically takes 1 to 2 weeks from start to finish.'
            },
            {
                id: 4,
                heading: 'Is a permit required for deck construction?',
                content: 'In many cases, yes. We help guide you through the permitting process and ensure compliance with local building codes.'
            }
        ]
    }

];

export default services;